import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { PaymentTransaction } from "@/types";

function PaymentTransactionBadge({
  type,
}: {
  type: PaymentTransaction["type"];
}) {
  return (
    <Badge
      variant={type === "revenue" ? "default" : "destructive"}
      className={cn(type === "revenue" && "bg-chart-2 dark:bg-chart-2")}
    >
      {type === "revenue" ? "Revenue" : "Expense"}
    </Badge>
  );
}

export default PaymentTransactionBadge;
